import React, { useContext, useEffect, useState } from "react";
import { Layout as AntLayout } from "antd";
import { useHistory } from "react-router-dom";

import Header from "../Header/Header";
import Nav from "../Nav/Nav";
import { useAuth } from "../../hooks/useAuth";
import KineticaLogo from "../../images/logo.svg";
import { ADMIN_LAYOUT, AlertContext } from "../../constants";
import tokens from "../../styles/tokens";

const { Sider, Content } = AntLayout;

const Layout = (props) => {
  const auth = useAuth();
  const history = useHistory();
  const alerts = useContext(AlertContext);
  const { children } = props;

  const [contentHeight, setContentHeight] = useState();

  const handleHomeClick = () => {
    history.push("/");
  };

  useEffect(() => {
    const handleResize = () => {
      const height =
        process.env.REACT_APP_ENV === "prod"
          ? window.innerHeight - alerts.length * 83
          : window.innerHeight - alerts.length * 83 - 20;
      setContentHeight(height);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [alerts]);

  return (
    <>
      <AntLayout hasSider>
        <Sider
          width={280}
          style={{
            background: tokens.surface[100],
            borderRight: `1px solid ${tokens.border.glow}`,
            boxShadow: tokens.shadow.glowKinetica,
          }}
        >
          <div
            style={
              process.env.REACT_APP_ENV === "prod"
                ? {
                    height:
                      alerts.length > 0
                        ? `calc(100vh - ${alerts.length * 83}px)`
                        : "100vh",
                    backgroundColor: undefined,
                  }
                : {
                    height:
                      alerts.length > 0
                        ? `calc(100vh - ${alerts.length * 83 - 20}px)`
                        : "calc(100vh - 20px)",
                    backgroundColor: undefined,
                  }
            }
          >
            <div
              onClick={handleHomeClick}
              style={{
                cursor: "pointer",
                padding: ADMIN_LAYOUT.LOGO.padding,
                textAlign: auth.user ? "right" : "left",
              }}
            >
              <img
                src={KineticaLogo}
                style={{
                  height: ADMIN_LAYOUT.LOGO.height,
                }}
                alt="Kinetica Logo"
              />
              <h1
                style={{
                  color: tokens.surface[800],
                  fontSize: ADMIN_LAYOUT.SUBTITLE.fontSize,
                  fontWeight: 300,
                  letterSpacing: "-0.02em",
                  marginTop: "8px",
                }}
              >
                SaaS Admin Portal
              </h1>
            </div>
            <Nav />
          </div>
        </Sider>
        <AntLayout>
          <Content>
            <div
              style={{
                padding: ADMIN_LAYOUT.CONTENT.padding,
                height: contentHeight,
                overflowY: "auto",
                backgroundColor: tokens.surface[50],
                color: tokens.surface[950],
              }}
            >
              <Header />
              {React.cloneElement(children, { ...props })}
            </div>
          </Content>
        </AntLayout>
      </AntLayout>
    </>
  );
};

export default Layout;
